import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  console.log("totalPagestotalPages",totalPages)
const getPageNumbers = () => {
  const pages: (number | string)[] = [];
  const maxButtons = 5; // allow more buttons before collapsing

  // If total pages is less than or equal to maxButtons, just show all
  if (totalPages <= maxButtons) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return pages;
  }

  const middleButtons = maxButtons - 2; // slots excluding first & last
  let startPage = Math.max(2, currentPage - Math.floor(middleButtons / 2));
  let endPage = startPage + middleButtons - 1;

  // Adjust if endPage exceeds totalPages
  if (endPage >= totalPages) {
    endPage = totalPages - 1;
    startPage = endPage - middleButtons + 1;
  }

  pages.push(1); // Always show first page

  if (startPage > 2) pages.push("...");

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  if (endPage < totalPages - 1) pages.push("...");

  pages.push(totalPages); // Always show last page

  return pages;
};



  return (
    <div className="flex items-center justify-end my-4 gap-2 " >

      {
        totalPages >0 &&(<>
              {/* Previous Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300"
        disabled={currentPage === 1}
      >
        ‹
      </button>



      {getPageNumbers().map((page: any, idx: number) => (
        <button
          key={idx}
          onClick={() => typeof page === 'number' && onPageChange(page)}
          disabled={page === '...'}
          className={`w-8 h-8 flex items-center justify-center rounded-full font-medium
      ${page === currentPage
              ? "bg-red-600 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"}
      ${page !== '...' ? 'sm:inline' : 'sm:hidden'} // hide extra on small screens
    `}
        >
          {page}
        </button>
      ))}

      {/* Page Numbers */}
      {/* {[...Array(100)].map((_, index) => {

        
        const page = index + 1;
        return (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-8 h-8 flex items-center justify-center rounded-full font-medium ${
              page === currentPage
                ? "bg-red-600 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            {page}
          </button>
        );
      })} */}

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300"
        disabled={currentPage === totalPages}
      >
        ›
      </button>
     </> )
      }
    </div>
  );
};

export default Pagination;
